import { Box, SecondaryButton, Switch } from '@cko/primitives';
import React from 'react';
import { useDeveloperToolsProvider } from '../../context';

export const OverlayToolbar = () => {
  const { setShowOverridesOnly, showOverridesOnly, resetOverride } = useDeveloperToolsProvider();
  return (
    <Box
      style={{
        display: 'grid',
        alignItems: 'center',
        gap: 'var(--layout-shoe)',
        gridTemplateColumns: '135px 240px',
      }}
    >
      <SecondaryButton onClick={resetOverride}>Reset Overrides</SecondaryButton>
      <Switch
        label="Show overrides only"
        checked={showOverridesOnly}
        onClick={() => setShowOverridesOnly(!showOverridesOnly)}
      />
    </Box>
  );
};
